import experimentFlagsHelper from '@zola-helpers/client/dist/es/util/experimentFlagsHelper';
import experimentsFlagsHelperSSR from '@zola-helpers/server/dist/es/experiments';

// LogRocket Keys
export const LOGROCKET_PLANNING_ONBOARD_FLAG = 'logrocket-planning-onboard';
export const LOGROCKET_WEBSITE_ONBOARD = 'logrocket-website-onboard';
export const SUPER_LINK_LOG_ROCKET = 'magic-link-log-rocket'; // CE-847 https://newamsterdamlabs.atlassian.net/browse/CE-847
export const LOGROCKET_INVITES_PDP = 'logrocket-invites-pdp'; // COMMERCE-585 https://newamsterdamlabs.atlassian.net/browse/COMMERCE-585
export const LOGROCKET_YOUR_WEDDING_V2 = 'logrocket-your-wedding-v2';
export const LOGROCKET_WEBSITE_V2_MOBILE_DEBUG = 'logrocket-website-v2-mobile-debug';

// Experiment Keys
export const REGISTRY_GIFT_GIVER_TILE_HEIGHT = 'registry-gift-giver-tile-height'; // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-929
export const REGISTRY_GIFT_GIVER_PDP_BADGE = 'registry-gift-giver-pdp-badge'; // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-931
export const HOME_NEWNESS = 'home-newness';
export const DESKTOP_TO_APP_ENABLED = 'desktop-to-app-enabled'; // https://newamsterdamlabs.atlassian.net/browse/CE-1417
export const DSTD_WEDDING_WEBSITE_ENTRYPOINT = 'dstd-wedding-website-entrypoint-ii'; // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-1133
export const HDYHAU_SUBWAY = 'hdyhau-subway';
export const DSTD_NAV_ENTRY = 'dstd-navigation-entry';
export const WEBSITE_TO_REGISTRY_V2 = 'website-to-registry-v2'; // https://newamsterdamlabs.atlassian.net/browse/CE-1848
export const CHAR_COUNT_INCREASE = 'website-char-count-increase'; // https://newamsterdamlabs.atlassian.net/browse/CE-1876
export const RECAPTCHA_REFACTOR = 'recaptcha-refactor'; // https://newamsterdamlabs.atlassian.net/browse/CE-2186
export const PAPER_PLP_PRICE_DISPLAY = 'paper-plp-price-display'; // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-1941
export const WEBSITE_V2 = 'website-v2';
export const ONBOARDING_GP_MOBILE_JAN_2023 = 'onboarding-gp-mobile-jan-2023'; // https://newamsterdamlabs.atlassian.net/browse/CE-2908
export const CORE_POST_AUTH_NAV_V3 = 'core-post-auth-nav-v3';
export const ONBOARDING_GP_MOBILE_DROP_STEPS = 'onboard-gp-mobile-drop-extra-steps';
export const PAPER_PLP_SALE_EVENT = 'paper-invite-ty-sale-event';
export const YW_CUSTOMIZE_MODULE_ORDERING = 'yw-customize-module-ordering'; // https://newamsterdamlabs.atlassian.net/browse/CE-3023
export const ONBOARDING_REGISTRY_VALUABLE = 'onboarding-registry-valuable'; // https://newamsterdamlabs.atlassian.net/browse/CE-3163
export const WEBSITE_ONBOARDING_SKIP_PLP = 'website-onboarding-skip-plp-v2'; // https://newamsterdamlabs.atlassian.net/browse/CE-3202
export const EXTERNAL_REGISTRIES_SYNCHING_MESSAGING = 'external-registries-synching-messaging';
export const HERO_IMAGE_CUSTOMIZATION = 'hero-image-customization'; // https://newamsterdamlabs.atlassian.net/browse/CE-3257

// Season Flags
export const HOLIDAYS_2022 = 'holidays2022';

// Promo flags

const FALLBACK_VARIATIONS = {
  // LogRocket Flags
  [LOGROCKET_PLANNING_ONBOARD_FLAG]: experimentFlagsHelper.createExperimentFlags(),
  [LOGROCKET_WEBSITE_ONBOARD]: experimentFlagsHelper.createExperimentFlags(),
  [SUPER_LINK_LOG_ROCKET]: experimentFlagsHelper.createExperimentFlags(),
  [LOGROCKET_INVITES_PDP]: experimentFlagsHelper.createExperimentFlags(),
  [LOGROCKET_YOUR_WEDDING_V2]: experimentFlagsHelper.createExperimentFlags(),
  [LOGROCKET_WEBSITE_V2_MOBILE_DEBUG]: experimentFlagsHelper.createExperimentFlags(),
  // Experiment Flags
  [HOME_NEWNESS]: experimentFlagsHelper.createExperimentFlags(),
  [REGISTRY_GIFT_GIVER_TILE_HEIGHT]: experimentFlagsHelper.createExperimentFlags(),
  [REGISTRY_GIFT_GIVER_PDP_BADGE]: experimentFlagsHelper.createExperimentFlags(),
  [DESKTOP_TO_APP_ENABLED]: experimentFlagsHelper.createExperimentFlags(),
  [DSTD_WEDDING_WEBSITE_ENTRYPOINT]: experimentFlagsHelper.createExperimentFlags(),
  [HDYHAU_SUBWAY]: experimentFlagsHelper.createExperimentFlags(),
  [DSTD_NAV_ENTRY]: experimentFlagsHelper.createExperimentFlags(),
  [RECAPTCHA_REFACTOR]: experimentFlagsHelper.createExperimentFlags(),
  [PAPER_PLP_PRICE_DISPLAY]: experimentFlagsHelper.createExperimentFlags(),
  [HOLIDAYS_2022]: experimentFlagsHelper.createExperimentFlags(),
  [WEBSITE_V2]: experimentsFlagsHelperSSR.createExperimentFlags(),
  [ONBOARDING_GP_MOBILE_JAN_2023]: experimentFlagsHelper.createExperimentFlags(),
  [ONBOARDING_GP_MOBILE_DROP_STEPS]: experimentFlagsHelper.createExperimentFlags(),
  [PAPER_PLP_SALE_EVENT]: experimentFlagsHelper.createExperimentFlags(),
  [CORE_POST_AUTH_NAV_V3]: experimentFlagsHelper.createExperimentFlags(),
  [YW_CUSTOMIZE_MODULE_ORDERING]: experimentFlagsHelper.createExperimentFlags(),
  [ONBOARDING_REGISTRY_VALUABLE]: experimentFlagsHelper.createExperimentFlags(),
  [WEBSITE_ONBOARDING_SKIP_PLP]: experimentFlagsHelper.createExperimentFlags(),
  [EXTERNAL_REGISTRIES_SYNCHING_MESSAGING]: experimentFlagsHelper.createExperimentFlags(),
  [HERO_IMAGE_CUSTOMIZATION]: experimentFlagsHelper.createExperimentFlags(),
};

export default experimentFlagsHelper.makeExperimentFlags(FALLBACK_VARIATIONS);

const FALLBACK_VARIATIONS_SSR = {
  [WEBSITE_V2]: experimentsFlagsHelperSSR.createExperimentFlags(),
  [YW_CUSTOMIZE_MODULE_ORDERING]: experimentsFlagsHelperSSR.createExperimentFlags(),
};

export const experimentFlagsSSR = experimentsFlagsHelperSSR.makeExperimentFlags(
  FALLBACK_VARIATIONS_SSR
);

// Help function to check if variantion is in experiment
export const isInExperiment = (variant: string): boolean =>
  variant !== 'TEST-0' && variant !== 'NOT_IN_TEST' && /^TEST-[1-9]$/.test(variant);
